import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;
import { AnalyticsManagerService } from '../../providers/analytics-manager.service';

@Component({
  selector: 'app-nfl',
  templateUrl: './nfl.component.html',
  styleUrls: ['./nfl.component.css']
})
export class NflComponent implements OnInit {
  currentYear: any;

  public footers = [
    { 'title': 'About', 'description': 'About Description', 'path': 'about' },
    { 'title': 'Blog', 'description': '', 'path': '' },
    { 'title': 'FAQ', 'description': 'faq Description', 'path': 'faq' },
    { 'title': 'Rules', 'description': 'rules Description', 'path': 'rules' },
    { 'title': 'Support', 'description': 'welcomeSupport Description', 'path': 'welcomeSupport' },
    { 'title': 'Terms & Conditions', 'description': 'legal Description', 'path': 'legal' },
    { 'title': 'Privacy Policy', 'description': 'privacyPolicy Description', 'path': 'privacyPolicy' }
  ];

  constructor(private router: Router, public analyticsManager: AnalyticsManagerService) {
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit() {
    var self = this;
    var interval = setInterval(function () {
      if ($('.video-play') && $('.video-play').length > 0) {
        clearInterval(interval)
        $('.video-play').click(function () {

          self.analyticsManager.logEvent('View Video', { url: window.location.href })
          $(this).hide();
          if ($("#t-video").length == 0) {
            $(this).parent().append
              ('<iframe width="100%" height="350" class="frme-wdth" frameborder="0" wmode="Opaque" allowfullscreen="" src="https://www.youtube.com/embed/Izy3jkCqGXo?wmode=transparent?rel=0&autoplay=0" id="t-video" style="margin: 15px auto;width: 550px;"></iframe>')
            $("#t-video")[0].src = "https://www.youtube.com/embed/Izy3jkCqGXo?rel=0&autoplay=1&loop=1&playlist=Izy3jkCqGXo";
            $("#t-video").show();
          }
        });
        $(".testimonials-carousel").owlCarousel({
          autoplay: true,
          dots: true,
          loop: true,
          responsive: {
            0: {
              items: 1
            },
            768: {
              items: 2
            },
            900: {
              items: 3
            }
          }
        });

        // Clients carousel (uses the Owl Carousel library)
        $(".clients-carousel").owlCarousel({
          autoplay: true,
          dots: true,
          loop: true,
          responsive: {
            0: {
              items: 2
            },
            768: {
              items: 4
            },
            900: {
              items: 5
            }
          }
        });
      }

    }, 1000)
  }

  loadFooterContent(footer) {
    if (footer.title !== 'Blog') {
      this.router.navigate(['welcome', footer.path]);
    } else {
      window.open('http://blog.statementgames.com', '_self');
    }

  }

}
